const emptyDirections = () => [{}, {}, {}, {}];

const talentRow = (cost) => ({
    Cost: cost.toString(),
    Talents: ["", "", "", ""],
    Directions: emptyDirections(),
});

const abilityRow = (abilities, spans, costs) => ({
    Abilities: abilities,
    AbilitySpan: spans,
    Costs: costs,
    Directions: emptyDirections(),
});

const fourAcross = (cost) => abilityRow(["", "", "", ""], ["1", "1", "1", "1"], [cost, cost, cost, cost]);

export const blankTalentRows = () => [5, 10, 15, 20, 25].map(talentRow);

export const blankPowerRows = () => [abilityRow([""], ["4"], ["10"])];

export const blankSignatureRows = () => [
    abilityRow([""], ["4"], ["30"]),
    fourAcross("10"),
    fourAcross("15"),
];

const titled = () => ({ Title: "", Description: "" });

const MENTOR_ENTRIES = {
    Training: titled,
    TheCloneWars: titled,
    SurvivingThePurge: titled,
    MentorPersonality: () => ({ Style: "", Details: "" }),
    MentorComplications: () => ({ Complication: "", Details: "" }),
    MentorForceTraditions: () => ({
        Tradition: "",
        Description: "",
        Benefit: { Description: "", Discounts: [] },
        Drawback: { Description: "", Cost: 0 },
    }),
};

export const blankMentorEntry = (section) => MENTOR_ENTRIES[section]();

export const isBlankMentorEntry = (section, entry) =>
    JSON.stringify(entry) === JSON.stringify(blankMentorEntry(section));

export const blankMentorDiscount = () => ({ Power: "", Discount: 0 });

const BLANK_FIELDS = {
    careers: () => ({ CareerSkills: [], Specializations: [] }),
    specializations: () => ({ CareerSkills: [], TalentRows: blankTalentRows() }),
    forcePowers: () => ({ AbilityRows: blankPowerRows() }),
    signatureAbilities: () => ({
        Career: "",
        MatchingNodes: [false, false, false, false],
        AbilityRows: blankSignatureRows(),
    }),
};

export const blankItem = (file, key) => {
    if (file === "skills") {
        return { Key: key, skill: "New Item", characteristic: "Brawn", type: "General" };
    }
    return { Key: key, Name: "New Item", ...(BLANK_FIELDS[file]?.() || {}) };
};

export const cloneItem = (source, file, key) => {
    if (file === "skills") {
        return { ...source, Key: key, skill: `${source.skill || ""} COPY`.trim() };
    }
    return { ...source, Key: key, Name: `${source.Name || ""} COPY`.trim() };
};
